<template>
  <div class="switcher">
    <info-switcher></info-switcher>
    <balance></balance>
    <referral-button></referral-button>
  </div>
</template>

<script>
import InfoSwitcher from '@/components/account/InfoSwitcher.vue';
import ReferralButton from '@/components/account/ReferralButton.vue';
import Balance from '@/components/account/Balance.vue';

export default {
  components: {
    InfoSwitcher,
    ReferralButton,
    Balance,
  },
};
</script>
